import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ARFileBase64 } from 'src/app/models/procedure/procedure.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

@Injectable()
export class RestArFilesService extends BaseApiService {

  constructor(httpClient: HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
    super(httpClient, translate);
  }

  getAllFiles(): Observable<any> {
    return this.httpClient.get<any>(super.getUpsApiHost() + 'ArFile', {headers : this.authService.upsHttpHeaders});
  }

  uploadFile(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('File', file, file.name);
    return this.httpClient.post<any>(super.getUpsApiHost() + "ArFile", formData, { headers: this.authService.upsHttpHeaders });
  }

  deleteFile(id: number): Observable<any> {
    return this.httpClient.delete<any>(super.getUpsApiHost() + "ArFile/entity/" + id, {headers : this.authService.upsHttpHeaders});
  }

  getFile(file: any): Observable<any> {
    return this.httpClient.post<any>(super.getUpsApiHost() + "ArFile", file, {headers : this.authService.upsHttpHeaders});
  }

  getFileBase64(id: number): Observable<ARFileBase64> {
    return this.httpClient.get<ARFileBase64>(super.getUpsApiHost() + "ArFile/binary-data/base64/" + id, {headers : this.authService.upsHttpHeaders});
  }

}
